import { effects } from 'redux-saga'

import {
  LOAD_CLIENT_LIST,
  LOAD_CLIENTS,
  SEARCH_CLIENTS,
} from '../../modules/client'

import load from './load'
import loadList from './loadList'
import search from './search'

export default function* clientSaga({ invocation }) {
  yield [
    effects.takeEvery(LOAD_CLIENT_LIST, loadList, invocation),
    effects.takeEvery(LOAD_CLIENTS, load, invocation),
    effects.takeEvery(SEARCH_CLIENTS, search, invocation),
  ]
}

export const sagas = {
  load,
  loadList,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/client/index.js